export function convertAmountToCents(amount: number) {
    if (Number.isNaN(amount)) {
        return null;
    }

    return Math.round(amount * 100);
}
